import React from 'react';
import { AppVersionInfo } from '../types';

interface VersionInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
  info: AppVersionInfo;
}

export const VersionInfoModal: React.FC<VersionInfoModalProps> = ({ isOpen, onClose, info }) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-slate-900/40 backdrop-blur-sm animate-in fade-in duration-200"
      onClick={onClose}
      role="presentation"
    >
      <div
        role="dialog"
        aria-labelledby="version-info-title"
        onClick={e => e.stopPropagation()}
        className="bg-white rounded-2xl shadow-[0_24px_64px_-16px_rgba(0,0,0,0.18)] w-full max-w-lg max-h-[85vh] overflow-hidden flex flex-col border border-slate-100 animate-in zoom-in-95 duration-200"
      >
        <div className="px-5 pt-5 pb-3 border-b border-slate-100 flex justify-between items-start gap-3 shrink-0 bg-gradient-to-br from-amber-50/80 to-white">
          <div className="flex items-start gap-3">
            <div className="size-10 rounded-xl bg-amber-100/90 flex items-center justify-center text-amber-700 border border-amber-200/60 shadow-sm">
              <span className="material-symbols-outlined !text-[22px]">trophy</span>
            </div>
            <div>
              <h3 id="version-info-title" className="text-base font-semibold text-slate-800 tracking-tight">
                Versão do sistema
              </h3>
              <p className="text-lg font-bold text-primary-accent mt-0.5 tabular-nums">
                {info.versionLabel.trim() || '—'}
              </p>
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="p-1.5 -mr-1 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-full transition-colors"
            aria-label="Fechar"
          >
            <span className="material-symbols-outlined !text-[20px]">close</span>
          </button>
        </div>

        <div className="flex-1 overflow-y-auto custom-scrollbar px-5 py-4 space-y-5">
          <section>
            <h4 className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2 flex items-center gap-1.5">
              <span className="material-symbols-outlined !text-[14px] text-green-600">new_releases</span>
              Melhorias recentes
            </h4>
            <div className="text-[13px] text-slate-600 leading-relaxed whitespace-pre-wrap rounded-xl bg-slate-50/80 border border-slate-100 px-3.5 py-3 min-h-[3rem]">
              {info.improvements.trim() ? info.improvements : <span className="text-slate-400 italic">Nenhuma informação cadastrada.</span>}
            </div>
          </section>

          <section>
            <h4 className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2 flex items-center gap-1.5">
              <span className="material-symbols-outlined !text-[14px] text-secondary-accent">map</span>
              Roadmap
            </h4>
            <div className="text-[13px] text-slate-600 leading-relaxed whitespace-pre-wrap rounded-xl bg-slate-50/80 border border-slate-100 px-3.5 py-3 min-h-[3rem]">
              {info.roadmap.trim() ? info.roadmap : <span className="text-slate-400 italic">Nenhuma informação cadastrada.</span>}
            </div>
          </section>
        </div>

        <div className="px-5 py-3 border-t border-slate-100 bg-slate-50/50 shrink-0">
          <button
            type="button"
            onClick={onClose}
            className="w-full py-2.5 rounded-xl bg-primary-accent text-white text-sm font-semibold shadow-md shadow-primary-accent/20 hover:brightness-105 active:scale-[0.99] transition-all"
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
};
